import addRoute from '@/router/add-route';

const Orders = () => import('@/modules/orders/orders.vue');
const OrderForm = () => import('@/modules/orders/order-form.vue');
const OrderDetails = () => import('@/modules/orders/order-details.vue');
const OrderUpcomingInvoice = () => import('@/modules/invoices/invoice-upcoming.vue');

const orders = [
    addRoute({
        name: 'orders',
        path: '/orders',
        component: Orders,
    }),
    addRoute({
        name: 'add-order',
        path: '/orders/add/:customerId?',
        component: OrderForm,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'order-details',
        path: '/orders/:id',
        component: OrderDetails,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'order-details-invoice',
        path: '/orders/:id/invoice/:invoice',
        component: OrderDetails,
        root: {label: 'Lists', name: 'lists'},
    }),
    addRoute({
        name: 'order-upcoming-invoice',
        path: '/orders/:id/upcoming-invoice',
        component: OrderUpcomingInvoice,
        root: {label: 'Lists', name: 'lists'},
    }),
];

export default orders;
